import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faCogs} from '@fortawesome/pro-solid-svg-icons';
import {canViewSystem} from '../enablers';
import {SystemLabel} from '../locales';

export const systemActionRouteIcon = faCogs;

/**
 * Goto system
 * @param params
 * @returns Action
 */
export const systemActionRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'system-route',
	cb: () => dispatcher.trigger('nx:system'),
	enableTest: () => canViewSystem(),
	icon: systemActionRouteIcon,
	get label() {
		return SystemLabel.ROUTE;
	},
	routeMatch: /^system(\/?)/,
	...params,
});
